import { html, unsafeCSS } from 'lit';
import { query, customElement } from 'lit/decorators.js';
import { styles as specificAccordionStyles } from '../view/view.scss';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS } from '../../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzToggleWebComponent } from '../../../../../../../ui/gzToggle';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import {
  AntimalwareFileTypesStatus,
  AntimalwareOnAccessScanningProfileType,
  ModuleId,
  SectionId,
} from '@nirvana/shared/dtos/types/policies/common';
import { GzPolicyPanelAccordionTemplateWebComponent } from '../../../../../../common/policyPanel/uiSettings/accordionTemplate';
import _ from 'lodash';
import { FormGroupValue } from '../../../../../../../ui/gzForm/formGroup/types/form-group-value';
import { PolicyPanelManager } from '../../../../PolicyPanelManager';
import deepmerge from 'deepmerge';
import { toggleDisabled, toggleVisibility } from '../../../../../../../utils/htmlElement.utils';
import { USE_EXT_JS_VERSION } from '../../../../config/config';
import {
  AntimalwareOnAccessFormValue,
  AntimalwareOnAccessSearchableKeywords,
} from '../../../../utils/uiSettings/antimalware/antimalware.types';
import {
  ANTIMALWARE_ON_ACCESS_DEFAULT_VALUE,
  getAntimalwareOnAccessDefaultProfileDataSettings,
  getAntimalwareOnAccessScanningGeneralArchivesDepthFormOptions,
  getAntimalwareOnAccessScanningGeneralScanActionInfectedFilesActionFormOptions, getAntimalwareOnAccessScanningGeneralScanActionNetworkFilesActionFormOptions,
  getAntimalwareOnAccessScanningGeneralScanActionPuaActionFormOptions,
  getAntimalwareOnAccessScanningGeneralSettingsFileTypesStatusFormOptions,
  getAntimalwareOnAccessSearchableKeywords,
  MAX_ARCHIVE_SIZE,
  MAX_LIMIT_FILE_SIZE,
  MIN_ARCHIVE_SIZE,
  MIN_LIMIT_FILE_SIZE,
} from '../../../../utils/uiSettings/antimalware/antimalware.values';
import { FontSizes, FontWeights } from '../../../../../../../types/common/types';
import { GzSelectionCardGroupWebComponent } from '../../../../../../../ui/gzSelectionCardGroup';
import { GzCheckboxWebComponent } from '../../../../../../../ui/gzCheckbox';
import { GzDropdownWebComponent } from '../../../../../../../ui/gzDropdown';
import { GzChipsGeneratorInputWebComponent } from '../../../../../../../ui/gzChipsGeneratorInput';
import { GzInputNumberWebComponent, InputWidthValues } from '../../../../../../../ui/gzInput';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { GzAntimalwareOnAccessUnixPathsTableWebComponent } from '../gridComponents/GzAntimalwareOnAccessUnixPathsTableWebComponent';
import { FormGroupChild } from '../../../../../../../ui/gzForm/formGroup/types/form-group-children';
import { Subscription } from 'rxjs';
import {
  getModuleLabelById,
  getSectionLabelById,
} from '../../../../searchableComponents/searchablePolicyPanel/utils/treeItems';
import { Feature } from '@nirvana/shared/constants';
import { InfoBoxSeverity } from '../../../../../../../ui/gzInfoBox/types';
import { GzTextWebComponent } from '../../../../../../../ui/gzText';
import { GzInfoBoxWebComponent } from '../../../../../../../ui/gzInfoBox';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS)
export class GzAntimalwareOnAccessWebComponent extends GzPolicyPanelAccordionTemplateWebComponent<
  AntimalwareOnAccessFormValue,
  AntimalwareOnAccessSearchableKeywords
> {
  protected path = {
    moduleId: ModuleId.ANTIMALWARE,
    sectionId: SectionId.ANTIMALWARE_ON_ACCESS,
  };
  protected searchableKeywords = getAntimalwareOnAccessSearchableKeywords();

  private settingsFormGroup!: FormGroup;
  private propsChangedFromInside = false;
  private sectionsImpactedByOnAccessToggle: string[] = [];

  @query('#antimalware-on-access-toggle')
  private onAccessEnableField: GzFormFieldWebComponent<GzToggleWebComponent, boolean>;
  @query('#antimalware-on-access-info-text')
  private onAccessInfoText: GzTextWebComponent;
  @query('#antimalware-on-access-info-box')
  private onAccessInfoBox: GzInfoBoxWebComponent;
  @query('#antimalware-on-access-content')
  private onAccessContent: HTMLElement;
  @query('#antimalware-on-access-scanning-profile-field')
  private onAccessScanningProfileField: GzFormFieldWebComponent<GzSelectionCardGroupWebComponent>;
  @query('#antimalware-on-access-settings-local-file-enable-field')
  private onAccessSettingsLocalFileEnableField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-local-file-type-field')
  private onAccessSettingsLocalFileTypeField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#antimalware-on-access-settings-local-file-extensions-field')
  private onAccessSettingsLocalFileExtensionsField: GzFormFieldWebComponent<GzChipsGeneratorInputWebComponent>;
  @query('#antimalware-on-access-settings-network-file-enable-field')
  private onAccessSettingsNetworkFileEnableField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-network-file-type-field')
  private onAccessSettingsNetworkFileTypeField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#antimalware-on-access-settings-network-file-extensions-field')
  private onAccessSettingsNetworkFileExtensionsField: GzFormFieldWebComponent<GzChipsGeneratorInputWebComponent>;
  @query('#antimalware-on-access-settings-general-limit-file-enable-field')
  private onAccessSettingsGeneralLimitFileEnableField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-general-limit-file-size-field')
  private onAccessSettingsGeneralLimitFileSizeField: GzFormFieldWebComponent<GzInputNumberWebComponent>;

  // general.miscellaneous
  @query('#antimalware-on-access-settings-general-miscellaneous-scan-files-field')
  private onAccessSettingsGeneralMiscellaneousScanFilesField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-general-miscellaneous-scan-sectors-field')
  private onAccessSettingsGeneralMiscellaneousScanSectorsField: GzFormFieldWebComponent<
    GzCheckboxWebComponent,
    boolean
  >;
  @query('#antimalware-on-access-settings-general-miscellaneous-scan-process-field')
  private onAccessSettingsGeneralMiscellaneousScanProcessField: GzFormFieldWebComponent<
    GzCheckboxWebComponent,
    boolean
  >;
  @query('#antimalware-on-access-settings-general-miscellaneous-scan-key-field')
  private onAccessSettingsGeneralMiscellaneousScanKeyField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-general-miscellaneous-scan-pua-field')
  private onAccessSettingsGeneralMiscellaneousScanPuaField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-general-miscellaneous-deferred-scanning-field')
  private onAccessSettingsGeneralMiscellaneousDeferredScanningField: GzFormFieldWebComponent<
    GzCheckboxWebComponent,
    boolean
  >;
  @query('#antimalware-on-access-settings-general-archives-enable-field')
  private onAccessSettingsGeneralArchivesEnableField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-general-archives-size-field')
  private onAccessSettingsGeneralArchivesSizeField: GzFormFieldWebComponent<GzInputNumberWebComponent>;
  @query('#antimalware-on-access-settings-general-archives-depth-field')
  private onAccessSettingsGeneralArchivesDepthField: GzFormFieldWebComponent<GzInputNumberWebComponent>;

  //general.scanActions
  @query('#antimalware-on-access-settings-general-scan-actions-infected-files-action-field')
  private onAccessSettingsGeneralScanActionsInfectedFilesActionField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#antimalware-on-access-settings-general-scan-actions-pua-action-field')
  private onAccessSettingsGeneralScanActionsInfectedPuaField: GzFormFieldWebComponent<GzDropdownWebComponent>;
  @query('#antimalware-on-access-settings-general-scan-actions-network-files-action-field')
  private onAccessSettingsGeneralScanActionsNetworkFilesField: GzFormFieldWebComponent<GzDropdownWebComponent>;


  // advanced
  @query('#antimalware-on-access-settings-advanced-on-access-unix-field')
  private onAccessSettingsAdvancedOnAccessUnixField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  @query('#antimalware-on-access-settings-advanced-on-access-unix-paths-field')
  private onAccessSettingsAdvancedOnAccessUnixPathsField: GzFormFieldWebComponent<GzAntimalwareOnAccessUnixPathsTableWebComponent>;

  /**
   * Current accordion styles merged with template styles.
   */
  static get styles() {
    return [...GzPolicyPanelAccordionTemplateWebComponent.styles, unsafeCSS(`${specificAccordionStyles}`)];
  }

  /**
   * Render specific title.
   */
  protected renderTitle() {
    return html`<gz-form-field id="antimalware-on-access-toggle" status-field>
      <gz-toggle
        class="content"
        searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccess].label}"
        gz-form-input
        @toggleChange="${this.onOnAccessToggleChange}"
      >
        <span>${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccess].translatedLabel}</span>
      </gz-toggle>
    </gz-form-field>`;
  }

  /**
   * Render specific info text.
   * @protected
   */
  protected renderInfoText() {
    return html`
      <gz-text
        id="antimalware-on-access-info-text"
        fontSize="${FontSizes.PARAGRAPH_12}"
        fontWeight="${FontWeights.NORMAL}"
        >${translateFn(
          'On-access Scanning blocks malware by scanning files, process memory, boot sectors, and potentially unwanted applications (PUA) upon access.'
        )}
      </gz-text>
    `;
  }

  /**
   * Render specific content.
   */
  protected renderContent() {
    // Set available sections disabled by on-access toggle
    this.setAvailableSectionsDisabledByOnAccessToggle();

    return html`
      <gz-info-box id="antimalware-on-access-info-box" severity="${InfoBoxSeverity.WARNING}" class="mt-2 hidden">
        ${translateFn('This action will disable the following modules: {modules}', {
          modules: this.sectionsImpactedByOnAccessToggle.join(', '),
        })}
      </gz-info-box>

      <div id="antimalware-on-access-content">
        <!-- On access - Scan options -->
        <div id="antimalware-on-access-profile-content" class="mt-4">
          <gz-title fontWeight="${FontWeights.SEMIBOLD}" fontSize="${FontSizes.PARAGRAPH_12}" class="subtitle"
            >${translateFn('Scan options')}</gz-title
          >

          <gz-form-field id="antimalware-on-access-scanning-profile-field" class="mt-2">
            <gz-selection-card-group gz-form-input @change="${this.onProfileTypeChange}">
              <gz-selection-card
                label="${translateFn('Aggressive')}"
                .value="${AntimalwareOnAccessScanningProfileType.AGGRESSIVE}"
              >
                <div slot="content">
                  <gz-title
                    fontSize="${FontSizes.PARAGRAPH_12}"
                    fontWeight="${FontWeights.SEMIBOLD}"
                    style="margin-bottom: 8px"
                    >${translateFn('Advanced security, moderate use of resources')}</gz-title
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' +
                    translateFn(
                      'Scan everything, including all accessed files from local and network drives, archives, low-risk files, emails, and web traffic.'
                    )}</gz-text
                  >
                </div>
              </gz-selection-card>
              <gz-selection-card
                label="${translateFn('Normal')}"
                .value="${AntimalwareOnAccessScanningProfileType.NORMAL}"
              >
                <div slot="content">
                  <gz-title
                    fontSize="${FontSizes.PARAGRAPH_12}"
                    fontWeight="${FontWeights.SEMIBOLD}"
                    style="margin-bottom: 8px"
                    >${translateFn('Standard security, low use of resources')}</gz-title
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' + translateFn('Scan for any type of malware')}</gz-text
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' +
                    translateFn(
                      'Scan all accessed files from local drives and accessed application files from network drives, excluding archives and low-risk files.'
                    )}</gz-text
                  >
                </div>
              </gz-selection-card>
              <gz-selection-card
                label="${translateFn('Permissive')}"
                .value="${AntimalwareOnAccessScanningProfileType.PERMISSIVE}"
              >
                <div slot="content">
                  <gz-title
                    fontSize="${FontSizes.PARAGRAPH_12}"
                    fontWeight="${FontWeights.SEMIBOLD}"
                    style="margin-bottom: 8px"
                    >${translateFn('Basic security, very low use of resources')}</gz-title
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' +
                    translateFn(
                      'Scan accessed application files from local and network drives, and incoming emails.'
                    )}</gz-text
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' +
                    translateFn(
                      'Do not scan low-risk files, outgoing emails, web traffic, spyware and not-so-dangerous malware.'
                    )}</gz-text
                  >
                </div>
              </gz-selection-card>
              <gz-selection-card
                label="${translateFn('Custom')}"
                .value="${AntimalwareOnAccessScanningProfileType.CUSTOM}"
              >
                <div slot="content">
                  <gz-title
                    fontSize="${FontSizes.PARAGRAPH_12}"
                    fontWeight="${FontWeights.SEMIBOLD}"
                    style="margin-bottom: 8px"
                    >${translateFn('Administrator-defined settings')}</gz-title
                  >
                  <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                    >${'- ' + translateFn('Configure the scan settings to match your preferences.')}</gz-text
                  >
                </div>
              </gz-selection-card>
            </gz-selection-card-group>
          </gz-form-field>
        </div>

        <!-- On access - Settings - File types -->
        <div id="antimalware-on-access-settings-general-file-content" class="mt-4">
          <gz-title
            fontWeight="${FontWeights.SEMIBOLD}"
            fontSize="${FontSizes.PARAGRAPH_12}"
            class="subtitle"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.FileLocation].label}"
            >${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.FileLocation].translatedLabel}</gz-title
          >

          <!-- On access - Settings - File types - Local -->
          <div id="antimalware-on-access-settings-general-scan-local-file-content" class="mt-2">
            <gz-form-field id="antimalware-on-access-settings-local-file-enable-field">
              <gz-checkbox
                searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanLocalFiles]
                  .label}"
                label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanLocalFiles].translatedLabel}"
                gz-form-input
                @change="${e => this.toggleGeneralLocalFileFieldDisabledState(!e.detail.checked)}"
              ></gz-checkbox>
            </gz-form-field>

            <gz-form-field
              class="helper-text"
              id="antimalware-on-access-settings-local-file-type-field"
              label="${translateFn('File types')}"
            >
              <gz-dropdown
                gz-form-input
                .options=${getAntimalwareOnAccessScanningGeneralSettingsFileTypesStatusFormOptions()}
                @selectionChanged="${this.handleGeneralLocalFileTypedChange}"
              ></gz-dropdown>
            </gz-form-field>

            <gz-form-field class="helper-text" id="antimalware-on-access-settings-local-file-extensions-field">
              <gz-chips-generator-input
                gz-form-input
                hasFloatingLabel
                .strings=${{
                  label: translateFn('Extensions'),
                  placeholder: translateFn('Separate extensions by comma or the Enter key.'),
                  hintText: translateFn('Each entry must be unique.'),
                  notUniqueErrorMessage: translateFn('The entry already exists.'),
                  clearListButtonText: translateFn('Clear list'),
                  searchPlaceholder: translateFn('Search'),
                  noSearchResultsString: translateFn('No results found'),
                  deleteWindowTitle: translateFn('Delete extensions?'),
                  deleteWindowContentText: translateFn(
                    'You are about to delete all extensions from the list. This action cannot be undone.'
                  ),
                  cancelClearListBtnString: translateFn('Cancel'),
                  clearListActionBtnString: translateFn('Delete'),
                }}
              >
              </gz-chips-generator-input>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </div>

          <!-- On access - Settings - File types - Network -->
          <div id="antimalware-on-access-settings-general-scan-network-file-content" class="mt-2">
            <gz-form-field id="antimalware-on-access-settings-network-file-enable-field">
              <gz-checkbox
                searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanNetworkFiles]
                  .label}"
                label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanNetworkFiles]
                  .translatedLabel}"
                gz-form-input
                @change="${e => this.toggleGeneralNetworkFileFieldDisabledState(!e.detail.checked)}"
              ></gz-checkbox>
            </gz-form-field>

            <gz-form-field
              class="helper-text"
              id="antimalware-on-access-settings-network-file-type-field"
              label="${translateFn('File types')}"
            >
              <gz-dropdown
                gz-form-input
                .options=${getAntimalwareOnAccessScanningGeneralSettingsFileTypesStatusFormOptions()}
                @selectionChanged="${this.handleGeneralNetworkFileTypedChange}"
              ></gz-dropdown>
            </gz-form-field>

            <gz-form-field class="helper-text" id="antimalware-on-access-settings-network-file-extensions-field">
              <gz-chips-generator-input
                gz-form-input
                hasFloatingLabel
                .strings=${{
                  label: translateFn('Extensions'),
                  placeholder: translateFn('Separate extensions by comma or press Enter.'),
                  hintText: translateFn('Each entry must be unique.'),
                  notUniqueErrorMessage: translateFn('The entry already exists.'),
                  clearListButtonText: translateFn('Clear list'),
                  searchPlaceholder: translateFn('Search'),
                  noSearchResultsString: translateFn('No results found'),
                  deleteWindowTitle: translateFn('Delete extensions?'),
                  deleteWindowContentText: translateFn(
                    'You are about to delete all extensions from the list. This action cannot be undone.'
                  ),
                  cancelClearListBtnString: translateFn('Cancel'),
                  clearListActionBtnString: translateFn('Delete'),
                }}
              >
              </gz-chips-generator-input>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </div>

          <!-- On access - Settings - File types - Limit -->
          <div class="checkbox-with-input" id="antimalware-on-access-settings-general-limit-file-content">
            <gz-form-field class="checkbox-width" id="antimalware-on-access-settings-general-limit-file-enable-field">
              <gz-checkbox
                label="${translateFn('Maximum size') + ':'}"
                gz-form-input
                @change="${e => toggleDisabled(this.onAccessSettingsGeneralLimitFileSizeField, !e.detail.checked)}"
              ></gz-checkbox>
            </gz-form-field>

            <gz-form-field id="antimalware-on-access-settings-general-limit-file-size-field">
              <gz-input-number
                gz-form-input
                .min=${MIN_LIMIT_FILE_SIZE}
                .max=${MAX_LIMIT_FILE_SIZE}
                unitSuffix="${translateFn('MB')}"
                inputWidth=${InputWidthValues.MEDIUM}
              ></gz-input-number>
            </gz-form-field>
          </div>
        </div>

        <!-- On access - Settings - Scan -->
        <div id="antimalware-on-access-settings-general-miscellaneous-content" class="mt-4">
          <gz-title
            fontWeight="${FontWeights.SEMIBOLD}"
            fontSize="${FontSizes.PARAGRAPH_12}"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.Scan].label}"
            class="subtitle"
            >${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.Scan].translatedLabel}</gz-title
          >

          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-scan-files-field" class="mt-2">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnlyNewOrChangedFiles]
                .label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnlyNewOrChangedFiles]
                .translatedLabel}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>
          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-scan-sectors-field">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.BootSectors].label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.BootSectors].translatedLabel}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>
          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-scan-process-field">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ProcessMemory].label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ProcessMemory].translatedLabel}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>
          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-scan-key-field">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ForKeyloggers].label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ForKeyloggers].translatedLabel}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>
          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-scan-pua-field">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ForPua].label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ForPua].translatedLabel}"
              @change="${e => this.handleGeneralMiscellaneousScanPuaChange(!e.detail.checked)}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>

          <div id="antimalware-on-access-settings-general-archives-content">
            <gz-form-field
              class="label-mw-250 checkbox-width"
              id="antimalware-on-access-settings-general-archives-enable-field"
            >
              <gz-checkbox
                searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.Archives].label}"
                label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.Archives].translatedLabel}"
                gz-form-input
                @change="${e => this.toggleGeneralArchiveDisabledState(!e.detail.checked)}"
              ></gz-checkbox>
            </gz-form-field>

            <gz-form-field
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ArchiveMaximumSize]
                .label}"
              class="helper-text"
              id="antimalware-on-access-settings-general-archives-size-field"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ArchiveMaximumSize]
                .translatedLabel}"
            >
              <gz-input-number
                gz-form-input
                inputWidth="${InputWidthValues.MEDIUM}"
                min="${MIN_ARCHIVE_SIZE}"
                max="${MAX_ARCHIVE_SIZE}"
                unitSuffix="${translateFn('MB')}"
              ></gz-input-number>
            </gz-form-field>

            <gz-form-field
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ArchiveMaximumDepth]
                .label}"
              class="helper-text"
              id="antimalware-on-access-settings-general-archives-depth-field"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ArchiveMaximumDepth]
                .translatedLabel}"
            >
              <gz-dropdown
                gz-form-input
                .options=${getAntimalwareOnAccessScanningGeneralArchivesDepthFormOptions()}
              ></gz-dropdown>
            </gz-form-field>
          </div>

          <gz-form-field id="antimalware-on-access-settings-general-miscellaneous-deferred-scanning-field">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.DeferredScanning]
                .label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.DeferredScanning].translatedLabel}"
              gz-form-input
            ></gz-checkbox>
          </gz-form-field>
        </div>

        <!-- On access - Settings - Scan actions -->
        <div id="antimalware-on-access-settings-general-scan-actions-content" class="mt-4">
          <gz-title
            fontWeight="${FontWeights.SEMIBOLD}"
            fontSize="${FontSizes.PARAGRAPH_12}"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanActions].label}"
            class="subtitle"
            >${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.ScanActions].translatedLabel}</gz-title
          >

          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}" class="infoText mt-1"
            >${translateFn('You can configure automatic response actions for detected threats based on their type.')}
          </gz-text>

          <gz-form-field
            class="mt-2"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.DefaultAction].label}"
            id="antimalware-on-access-settings-general-scan-actions-infected-files-action-field"
            label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.DefaultAction].translatedLabel}"
          >
            <gz-dropdown
              gz-form-input
              .options=${getAntimalwareOnAccessScanningGeneralScanActionInfectedFilesActionFormOptions()}
              inputWidth=${InputWidthValues.MEDIUM}
            ></gz-dropdown>
          </gz-form-field>

          <gz-form-field
            class="mt-2"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.PuaAction].label}"
            id="antimalware-on-access-settings-general-scan-actions-pua-action-field"
            label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.PuaAction].translatedLabel}"
          >
            <gz-dropdown
              gz-form-input
              .options=${getAntimalwareOnAccessScanningGeneralScanActionPuaActionFormOptions()}
              inputWidth=${InputWidthValues.MEDIUM}
            ></gz-dropdown>
          </gz-form-field>

          <gz-form-field
            class="mt-2"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.NetworkFilesAction].label}"
            id="antimalware-on-access-settings-general-scan-actions-network-files-action-field"
            label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.NetworkFilesAction].translatedLabel}"
          >
            <gz-dropdown
              gz-form-input
              .options=${getAntimalwareOnAccessScanningGeneralScanActionNetworkFilesActionFormOptions()}
              inputWidth=${InputWidthValues.MEDIUM}
            ></gz-dropdown>
          </gz-form-field>
        </div>

        <!-- On access - On-access for linux -->
        <div id="antimalware-on-access-settings-advanced-content" class="mt-4">
          <gz-title
            fontWeight="${FontWeights.SEMIBOLD}"
            fontSize="${FontSizes.PARAGRAPH_12}"
            searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccessForLinux].label}"
            class="subtitle"
            >${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccessForLinux]
              .translatedLabel}</gz-title
          >

          <gz-form-field id="antimalware-on-access-settings-advanced-on-access-unix-field" class="mt-2">
            <gz-checkbox
              searchable-label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccessScanning]
                .label}"
              label="${this.searchableKeywords[AntimalwareOnAccessSearchableKeywords.OnAccessScanning].translatedLabel}"
              gz-form-input
              @change="${e => toggleDisabled(this.onAccessSettingsAdvancedOnAccessUnixPathsField, !e.detail.checked)}"
            ></gz-checkbox>
          </gz-form-field>

          <gz-form-field id="antimalware-on-access-settings-advanced-on-access-unix-paths-field">
            <gz-policy-panel-antimalware-on-access-unix-paths-table
              class="dataTableColumnWidth600"
              gz-form-input
            ></gz-policy-panel-antimalware-on-access-unix-paths-table>
          </gz-form-field>
        </div>
      </div>
    `;
  }

  /**
   * Get data from manager and set missing fields.
   * Fields used in this section:
   * - uiSettings.antimalware.onAccess
   */
  protected getValueFromManager(): AntimalwareOnAccessFormValue {
    // get default value
    const defaultValue = {
      uiSettings: {
        [ModuleId.ANTIMALWARE]: { [SectionId.ANTIMALWARE_ON_ACCESS]: ANTIMALWARE_ON_ACCESS_DEFAULT_VALUE },
      },
    };

    // get value from manager
    const value = {
      uiSettings: {
        [ModuleId.ANTIMALWARE]: {
          [SectionId.ANTIMALWARE_ON_ACCESS]: PolicyPanelManager.getInstance().getPolicy(
            'uiSettings.antimalware.onAccess'
          ),
        },
      },
    };

    // merge received value with default one
    return deepmerge(defaultValue, value);
  }

  /**
   * Create form group.
   */
  protected createFormGroup() {
    this.settingsFormGroup = FormGroup.build({
      general: {
        fileTypes: {
          scanLocalFile: {
            enable: this.onAccessSettingsLocalFileEnableField,
            settings: {
              fileType: this.onAccessSettingsLocalFileTypeField,
              extensions: this.onAccessSettingsLocalFileExtensionsField,
            },
          },
          scanNetworkFile: {
            enable: this.onAccessSettingsNetworkFileEnableField,
            settings: {
              fileType: this.onAccessSettingsNetworkFileTypeField,
              extensions: this.onAccessSettingsNetworkFileExtensionsField,
            },
          },
          limitFile: {
            enable: this.onAccessSettingsGeneralLimitFileEnableField,
            size: this.onAccessSettingsGeneralLimitFileSizeField,
          },
        },
        archives: {
          enable: this.onAccessSettingsGeneralArchivesEnableField,
          limitArchiveSize: this.onAccessSettingsGeneralArchivesSizeField,
          maximumArchiveDepth: this.onAccessSettingsGeneralArchivesDepthField,
        },
        miscellaneous: {
          scanBootSectors: this.onAccessSettingsGeneralMiscellaneousScanSectorsField,
          scanOnlyNewChangeFiles: this.onAccessSettingsGeneralMiscellaneousScanFilesField,
          scanForKeyloggers: this.onAccessSettingsGeneralMiscellaneousScanKeyField,
          scanPUA: this.onAccessSettingsGeneralMiscellaneousScanPuaField,
          deferredScanning: this.onAccessSettingsGeneralMiscellaneousDeferredScanningField,
          scanProcessMemory: this.onAccessSettingsGeneralMiscellaneousScanProcessField,
        },
        scanAction: {
          infectedFiles: {
            action: this.onAccessSettingsGeneralScanActionsInfectedFilesActionField,
          },
          pua: {
            action: this.onAccessSettingsGeneralScanActionsInfectedPuaField,
          },
          networkFiles: {
            action: this.onAccessSettingsGeneralScanActionsNetworkFilesField
          }
        },
      },
      advanced: {
        onAccessUnix: this.onAccessSettingsAdvancedOnAccessUnixField,
        onAccessUnixPaths: this.onAccessSettingsAdvancedOnAccessUnixPathsField,
      },
    });

    this.settingsFormGroup.applyToFormGroupFields((formField: FormGroupChild) => {
      if (formField instanceof GzFormFieldWebComponent) {
        this.subscribeToFormField(formField);
      }
    });

    this.formGroup = FormGroup.build({
      uiSettings: {
        antimalware: {
          onAccess: {
            onAccessScanning: {
              enable: this.onAccessEnableField,
              profile: this.onAccessScanningProfileField,
              settings: this.settingsFormGroup,
            },
          },
        },
      },
    });
  }

  private subscribeToFormField(formField: GzFormFieldWebComponent): void {
    const subscription: Subscription = formField.value$.subscribe(() => {
      if (this.propsChangedFromInside) {
        return;
      }

      this.onAccessScanningProfileField.value = AntimalwareOnAccessScanningProfileType.CUSTOM;
    });
    this.subscriptions.push(subscription);
  }

  /**
   * Set form group value.
   */
  protected async setFormData() {
    if (!this.valueT) {
      return;
    }

    this.propsChangedFromInside = true;

    // set form group value
    this.formGroup.value = {
      uiSettings: {
        antimalware: {
          onAccess: {
            onAccessScanning: {
              enable: this.valueT.uiSettings.antimalware.onAccess.onAccessScanning.enable,
              profile: this.valueT.uiSettings.antimalware.onAccess.onAccessScanning.profile,
              settings: {
                general: this.valueT.uiSettings.antimalware.onAccess.onAccessScanning.settings.general,
                advanced: {
                  onAccessUnix:
                    this.valueT.uiSettings.antimalware.onAccess.onAccessScanning.settings.advanced.onAccessUnix,
                  onAccessUnixPaths:
                    this.valueT.uiSettings.antimalware.onAccess.onAccessScanning.settings.advanced.onAccessUnixPaths.map(
                      path => {
                        return { path: path };
                      }
                    ),
                },
              },
            },
          },
        },
      },
    };

    await this.updateComplete;
    this.propsChangedFromInside = false;
  }

  /**
   * Get form group value according to backend format.
   */
  protected getFormGroupValue(): FormGroupValue | null {
    if (!this.formGroup) {
      return null;
    }

    const value = _.cloneDeep(this.formGroup.value);

    // set advanced onAccessUnixPaths field
    const onAccessUnixPaths = _.get(
      value,
      ['uiSettings', 'antimalware', 'onAccess', 'onAccessScanning', 'settings', 'advanced', 'onAccessUnixPaths'],
      []
    );
    _.set(
      value,
      ['uiSettings', 'antimalware', 'onAccess', 'onAccessScanning', 'settings', 'advanced', 'onAccessUnixPaths'],
      onAccessUnixPaths.map((path: { path: string }) => path.path)
    );

    if (USE_EXT_JS_VERSION) {
      return _.get(value, ['uiSettings', 'antimalware', 'onAccess'], {});
    }

    return value;
  }

  /**
   * Set external section names that are disabled by on access toggle.
   * @private
   */
  private setAvailableSectionsDisabledByOnAccessToggle() {
    const policyManager = PolicyPanelManager.getInstance();
    this.sectionsImpactedByOnAccessToggle = [];

    if (policyManager.isSandboxEndpointSensorSectionAvailable()) {
      this.sectionsImpactedByOnAccessToggle.push(
        getModuleLabelById(ModuleId.SANDBOX) + ' > ' + getSectionLabelById(SectionId.ENDPOINT_SENSOR)
      );
    }

    if (policyManager.isAntimalwareDynamicThreatDefenseSectionAvailable()) {
      this.sectionsImpactedByOnAccessToggle.push(
        getModuleLabelById(ModuleId.ANTIMALWARE) +
          ' > ' +
          getSectionLabelById(SectionId.ANTIMALWARE_DYNAMIC_THREAT_DEFENSE)
      );
    }

    if (Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_FILELESS_ATTACK_VISIBLE])) {
      this.sectionsImpactedByOnAccessToggle.push(
        getModuleLabelById(ModuleId.ANTIMALWARE) + ' > ' + getSectionLabelById(SectionId.ANTIMALWARE_ON_EXECUTE)
      );
    }
  }

  /**
   * Enable/Disable form fields from other sections.
   * @param e
   */
  onOnAccessToggleChange(e: CustomEvent) {
    const isDisabled = !e.detail.checked;
    toggleDisabled(this.onAccessInfoText, isDisabled);
    toggleDisabled(this.onAccessContent, isDisabled);

    // change visibility only if there are sections that are impacted by on access toggle
    if (this.sectionsImpactedByOnAccessToggle.length > 0) {
      toggleVisibility(this.onAccessInfoBox, isDisabled);
    }

    PolicyPanelManager.getInstance().setAntimalwareSectionsMask(isDisabled);
  }

  /**
   * Enable/Disable general local settings fields.
   * Set validators for extensions field depending on the checkbox state.
   * @param disabled
   * @private
   */
  private async toggleGeneralLocalFileFieldDisabledState(disabled: boolean) {
    await this.updateComplete;
    toggleDisabled(this.onAccessSettingsLocalFileTypeField, disabled);
    toggleDisabled(this.onAccessSettingsLocalFileExtensionsField, disabled);

    // set validators for extensions field
    const isUserDefinedExtensions =
      this.onAccessSettingsLocalFileTypeField.value === AntimalwareFileTypesStatus.USER_DEFINED_EXTENTIONS;
    const hasValidators = !disabled && isUserDefinedExtensions;
    this.onAccessSettingsLocalFileExtensionsField.Validators = hasValidators
      ? [RequiredValidator(translateFn('Required field'))]
      : [];
    this.onAccessSettingsLocalFileExtensionsField.validate(true);
  }

  /**
   * Enable/Disable general network settings fields.
   * Set validators for extensions field depending on the checkbox state.
   * @param disabled
   * @private
   */
  private async toggleGeneralNetworkFileFieldDisabledState(disabled: boolean) {
    await this.updateComplete;
    toggleDisabled(this.onAccessSettingsNetworkFileTypeField, disabled);
    toggleDisabled(this.onAccessSettingsNetworkFileExtensionsField, disabled);
    toggleDisabled(this.onAccessSettingsGeneralScanActionsNetworkFilesField, disabled);

    // set validators for extensions field
    const isUserDefinedExtensions =
      this.onAccessSettingsNetworkFileTypeField.value === AntimalwareFileTypesStatus.USER_DEFINED_EXTENTIONS;
    const hasValidators = !disabled && isUserDefinedExtensions;
    this.onAccessSettingsNetworkFileExtensionsField.Validators = hasValidators
      ? [RequiredValidator(translateFn('Required field'))]
      : [];
    this.onAccessSettingsNetworkFileExtensionsField.validate(true);
  }

  /**
   * Show/hide general local file extensions field.
   * Set validators for extensions field depending on the file type.
   * @param event
   * @private
   */
  private async handleGeneralLocalFileTypedChange(event: CustomEvent) {
    await this.updateComplete;
    const isVisible = event.detail.value === AntimalwareFileTypesStatus.USER_DEFINED_EXTENTIONS;
    toggleVisibility(this.onAccessSettingsLocalFileExtensionsField, isVisible);

    const hasValidators = this.onAccessSettingsLocalFileEnableField.value && isVisible;
    this.onAccessSettingsLocalFileExtensionsField.Validators = hasValidators
      ? [RequiredValidator(translateFn('Required field'))]
      : [];
    this.onAccessSettingsLocalFileExtensionsField.validate(true);
  }

  /**
   * Show/hide general network file extensions field.
   * Set validators for extensions field depending on the file type.
   * @param event
   * @private
   */
  private async handleGeneralNetworkFileTypedChange(event: CustomEvent) {
    await this.updateComplete;
    const isVisible = event.detail.value === AntimalwareFileTypesStatus.USER_DEFINED_EXTENTIONS;
    toggleVisibility(this.onAccessSettingsNetworkFileExtensionsField, isVisible);

    const hasValidators = this.onAccessSettingsNetworkFileEnableField.value && isVisible;
    this.onAccessSettingsNetworkFileExtensionsField.Validators = hasValidators
      ? [RequiredValidator(translateFn('Required field'))]
      : [];
    this.onAccessSettingsNetworkFileExtensionsField.validate(true);
  }

  private async handleGeneralMiscellaneousScanPuaChange(disabled: boolean) {
    await this.updateComplete;

    toggleDisabled(this.onAccessSettingsGeneralScanActionsInfectedPuaField, disabled);
  }

  private toggleGeneralArchiveDisabledState(disabled: boolean) {
    toggleDisabled(this.onAccessSettingsGeneralArchivesSizeField, disabled);
    toggleDisabled(this.onAccessSettingsGeneralArchivesDepthField, disabled);
  }

  /**
   * Change values of form fields according to the selected profile type.
   * @param event
   * @private
   */
  private async onProfileTypeChange(event: CustomEvent) {
    this.propsChangedFromInside = true;

    // skip if custom profile is selected
    const isCustomProfile = event.detail.value === AntimalwareOnAccessScanningProfileType.CUSTOM;
    if (isCustomProfile) {
      return;
    }

    // get default profile data settings
    const defaultProfileDataSettings = getAntimalwareOnAccessDefaultProfileDataSettings(event.detail.value);
    if (defaultProfileDataSettings) {
      _.set(
        defaultProfileDataSettings,
        ['advanced', 'onAccessUnixPaths'],
        defaultProfileDataSettings.advanced.onAccessUnixPaths.map(path => {
          return { path: path };
        })
      );

      this.settingsFormGroup.value = defaultProfileDataSettings as unknown as FormGroupValue;
      await this.updateComplete;
    }

    this.propsChangedFromInside = false;
  }

  /**
   * Override reset method, because we need to reset also chips component and grid.
   */
  public reset() {
    super.reset();

    // reset input of chips generator
    let chipsGeneratorFormField = this.onAccessSettingsLocalFileExtensionsField.Input.shadowRoot?.querySelector(
      '#chips-generator-form-field'
    ) as GzFormFieldWebComponent<GzInputWebComponent, string>;
    chipsGeneratorFormField?.Input?.setFormValue('');

    chipsGeneratorFormField = this.onAccessSettingsNetworkFileExtensionsField.Input.shadowRoot?.querySelector(
      '#chips-generator-form-field'
    ) as GzFormFieldWebComponent<GzInputWebComponent, string>;
    chipsGeneratorFormField?.Input?.setFormValue('');

    // reset grid
    this.onAccessSettingsAdvancedOnAccessUnixPathsField.Input.reset();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS: GzAntimalwareOnAccessWebComponent;
  }
}
